<template lang="pug">
#graficoTemperatura
    apex-charts.component.apexcharts-canvas(
        type='line',
        height='300',
        :options='chartOptions',
        :series='series',
        ref='chart'
    )
</template>

<script>
import { GRAFICO_TEMPERATURA } from '@/utils/layouts/graficos';
import ApexCharts from 'vue-apexcharts';

const JANEIRO = 1;
const DEZEMBRO = 12;

export default {
    name: 'GraficoTemperatura',
    components: {
        ApexCharts
    },
    data() {
        return {
            historicoMedias: [],
            series: []
        };
    },

    props: {
        historico: {
            type: Object,
            required: true
        },
        extraOptions: {
            type: Object
        }
    },

    methods: {
        configureDados() {
            const historicoTemperaturaMinima = this.historico.temperaturaMinima;
            const historicoTemperaturaMaxima = this.historico.temperaturaMaxima;

            let historicoTemperaturaMedia = [];
            for (
                let index = 0;
                index < historicoTemperaturaMinima.length;
                index++
            ) {
                let data = { ...historicoTemperaturaMinima[index] };
                data.valor =
                    (historicoTemperaturaMinima[index].valor +
                        historicoTemperaturaMaxima[index].valor) /
                    2;
                historicoTemperaturaMedia.push(data);
            }
            this.historicoMedias = historicoTemperaturaMedia;

            let anos = _.uniq(
                _.map(this.historicoMedias, historico => historico.ano)
            );

            _.each(anos, ano => {
                let dadosAno = _.filter(
                    this.historicoMedias,
                    historico => historico.ano === ano
                );

                this.buildBarSeries(dadosAno, ano);
            });

            this.buildMediaMensal(
                historicoTemperaturaMaxima,
                'Média das temperaturas máximas'
            );
            this.buildMediaMensal(
                historicoTemperaturaMinima,
                'Média das temperaturas mínimas'
            );
        },

        buildBarSeries(dadosAno, ano) {
            let dadosOrdenados = _.orderBy(dadosAno, ['mes'], ['asc']);
            this.series.push({
                name: ano.toString(),
                type: 'column',
                data: _.map(dadosOrdenados, dado => dado.valor)
            });
        },

        buildMediaMensal(historico, nome) {
            let mediasMensais = [];

            for (let i = JANEIRO; i <= DEZEMBRO; i++) {
                let dadosMes = _.filter(historico, h => {
                    return h.mes === i;
                });

                let mediaMensal = _.meanBy(dadosMes, dado => dado.valor);

                mediasMensais.push(mediaMensal);
            }

            this.series.push({
                name: nome,
                type: 'line',
                data: mediasMensais
            });
        }
    },

    computed: {
        chartOptions() {
            if (this.extraOptions) {
                return Object.assign(GRAFICO_TEMPERATURA, this.extraOptions);
            }
            return GRAFICO_TEMPERATURA;
        }
    },

    mounted() {
        this.configureDados();
    }
};
</script>

<style scoped></style>
